import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminHomeRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/home',
}).lazy(() => import('pages/admin/Home/AdminHomePage/AdminHomePage').then((d) => d.Route));
